/* rc-hscroll — pin a section and translate just its card track sideways as the page scrolls,
   then release so the page continues (desktop only, motion-safe). Everything else (heading,
   panel) stays put and the cards keep their normal size; only the track moves, via a GPU
   transform that tracks the native scroll 1:1.

   Falls back to the section's own normal behaviour (e.g. a draggable carousel) on tablet/mobile,
   reduced motion, or when the cars already fit — signalled by the .is-hscroll-active class.

   Structure (per section):
     [data-rc-hscroll]                  the <section>
       [data-rc-hscroll-wrap]           tall spacer; height = pin height + scroll distance
         [data-rc-hscroll-pin]          position: sticky; top:0; min-height:100vh; overflow:hidden
           …heading / panel (stay put)…
           [data-rc-hscroll-track]      the card row that gets translated
*/
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    var wrap = root.querySelector('[data-rc-hscroll-wrap]');
    var pin = root.querySelector('[data-rc-hscroll-pin]');
    var track = root.querySelector('[data-rc-hscroll-track]');
    if (!wrap || !pin || !track) return;

    var distance = 0, lead = 0, ticking = false, resizeTimer = null;

    function render() {
      ticking = false;
      if (distance <= 0) return;
      var top = wrap.getBoundingClientRect().top;          // how far the wrap top is below the viewport top
      var p = top >= 0 ? 0 : (-top - lead);                 // subtract the lead-in: hold centred first
      if (p < 0) p = 0;                                     // during the lead-in the cars stay still, centred
      if (p > distance) p = distance;                       // clamp at the end
      track.style.transform = 'translate3d(' + (-p) + 'px, 0, 0)';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }

    function measure() {
      wrap.style.height = '';
      track.style.transform = '';
      distance = 0;
      root.classList.remove('is-hscroll-active');
      if (!DESKTOP.matches || REDUCE.matches) return;      // tablet/mobile + reduced motion → fallback
      root.classList.add('is-hscroll-active');             // switch into the pinned layout before measuring
      // The track may be inset (inside a centred container). Its visible window runs from its own
      // left edge to the right edge of the pin; translate the full content through that window.
      var trackLeft = track.getBoundingClientRect().left - pin.getBoundingClientRect().left;
      var windowW = pin.clientWidth - trackLeft;
      var d = track.scrollWidth - windowW;
      if (d <= 0) { root.classList.remove('is-hscroll-active'); return; }  // cars already fit → no pin
      distance = d;
      // Lead-in: once pinned the cars are centred in the viewport — hold them still for this many
      // pixels of scroll before the sideways motion starts, so they settle in the middle first.
      lead = Math.round(Math.min(pin.clientHeight * 0.28, 280));
      wrap.style.height = (pin.offsetHeight + distance + lead) + 'px';
      render();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(measure, 150); });
    window.addEventListener('load', measure);              // re-measure once fonts/images settle
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', measure);
    if (REDUCE.addEventListener) REDUCE.addEventListener('change', measure);

    measure();
  }

  function init() {
    var nodes = document.querySelectorAll('[data-rc-hscroll]');
    // Mark this page view as the "horizontal scroll" variant for analytics / A-B comparison.
    // Fires once per page: a GTM dataLayer push and a GA4 gtag event if either is present. The
    // control (toggle off) loads no script, so in GA4 you compare sessions WITH this event to
    // those without. (Pair with Shopify Rollouts to actually split the traffic.)
    if (nodes.length && !window.__rcHscrollTracked) {
      window.__rcHscrollTracked = true;
      try {
        (window.dataLayer = window.dataLayer || []).push({ event: 'rc_hscroll_view', rc_variant: 'horizontal' });
        if (typeof window.gtag === 'function') window.gtag('event', 'rc_hscroll_view', { rc_variant: 'horizontal' });
      } catch (e) {}
    }
    Array.prototype.forEach.call(nodes, setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
